import CaspianXxApiClientAndSurveyIdPairItem from '../../../Domain/CaspianXxApiClientAndSurveyIdPairItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import CaspianXXApiClientAndSurveyIdPairService from '../../../Services/CaspianXXApiClientAndSurveyIdPairService';

// Drives the GeneralEditWizzardBaseFigma create/edit wizard for CaspianXx client-survey pairs.
// A single page with <=6 fields renders as the compact centered DS modal.
export default class CaspianXXApiClientAndSurveyIdPairWindowDescription {
  static titleForCreate = 'Add CaspianXx Client Survey Id Pairs';
  static titleForEdit = 'Edit CaspianXx Client Survey Id Pairs';
  static entityName = 'CaspianXx Client Survey Id Pair';
  static nameField = 'Id';
  static itemType = CaspianXxApiClientAndSurveyIdPairItem;
  static serviceFunction = CaspianXXApiClientAndSurveyIdPairService.Edit;
  static messageOnSuccess = 'CaspianXx Client Survey Id Pair has been saved.';
  static finishButtonLabel = 'Save CaspianXx Client Survey Id Pair';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'ClientSassieId',
          label: 'ClientSassieId',
          className: 'col-6',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'SurveySassieId',
          label: 'SurveySassieId',
          className: 'col-6',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Option1',
          label: 'Option1',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'StartDate',
          label: 'StartDate',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'EndDate',
          label: 'EndDate',
          className: 'col-6',
          type: InputTypesEnum.DateWithIndefinite,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'IsActive',
          label: 'IsActive',
          className: 'col-6',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
      ],
    },
  ];
}
